export default "__VITE_PUBLIC_ASSET__da91fef0__"